import { SettingState, SettingActions, SET_SETTING_PENDING, SET_SETTINGS } from "../types";


const initState: SettingState = {
  pending: false,
  folder: '',
  archiveFolder: '',
};

export default function settingReducer(state = initState, action: SettingActions): SettingState {
  switch (action.type) {
    case SET_SETTING_PENDING:
      return {
        ...state,
        pending: action.pending
      };
    case SET_SETTINGS:
      return {
        ...state,
        ...action.settings,
      };
    default:
      return state;
  }
}